import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import '../styles/Navigation.css';

const Navigation = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setIsMobileMenuOpen(false);
    }
  };

  const navLinks = [
    { label: 'About', section: 'about' },
    { label: 'Specializations', section: 'specializations' },
    { label: 'Experience', section: 'timeline' },
    { label: 'Services', section: 'services' },
    { label: 'Testimonials', section: 'testimonials' },
    { label: 'Contact', section: 'locations' }
  ];

  return (
    <nav className={`navigation ${isScrolled ? 'scrolled' : ''}`}>
      <div className="nav-container">
        <div className="nav-logo" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
          <span className="logo-text">Dr. Rajesh Kumar</span>
          <span className="logo-subtitle">Cardiologist</span>
        </div>

        <div className="nav-desktop">
          <ul className="nav-links">
            {navLinks.map((link) => (
              <li key={link.section}>
                <button onClick={() => scrollToSection(link.section)} className="nav-link">
                  {link.label}
                </button>
              </li>
            ))}
          </ul>
          <button onClick={() => scrollToSection('booking')} className="nav-cta-button">
            Book Appointment
          </button>
        </div>

        <button 
          className="mobile-menu-toggle"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {isMobileMenuOpen && (
        <div className="mobile-menu">
          <ul className="mobile-nav-links">
            {navLinks.map((link) => (
              <li key={link.section}>
                <button onClick={() => scrollToSection(link.section)} className="mobile-nav-link">
                  {link.label}
                </button>
              </li>
            ))}
            <li>
              <button onClick={() => scrollToSection('booking')} className="mobile-nav-cta">
                Book Appointment
              </button>
            </li>
          </ul>
        </div>
      )}
    </nav>
  );
};

export default Navigation;
